<template>
  <div v-if="!returnFourhSection">
    <form @submit.prevent="onSubmit">
      <h4>
        22. Da li ste zainteresovani da saznate nešto više o pravima osoba s
        invaliditetom?
      </h4>
      <div class="button-container">
        <div class="checkbox-label">
          <RadioButton
            name="rightsOfPersonsWithDisabilities"
            value="Da"
            inputId="rightsOfPersonsWithDisabilities-da"
            v-model="selectAnswerT"
          />
          <label for="rightsOfPersonsWithDisabilities-da" class="label">Da</label>

          <RadioButton
            name="rightsOfPersonsWithDisabilities"
            value="Ne"
            inputId="rightsOfPersonsWithDisabilities-ne"
            v-model="selectAnswerT"
          />
          <label for="rightsOfPersonsWithDisabilities-ne" class="label">Ne</label>

          <RadioButton
            name="rightsOfPersonsWithDisabilities"
            value="Ne znam"
            inputId="rightsOfPersonsWithDisabilities-neznam"
            v-model="selectAnswerT"
          />
          <label for="rightsOfPersonsWithDisabilities-neznam" class="label">Ne znam</label>
        </div>
      </div>

      <h4>23. Da li govorite neki od stranih jezika?</h4>
      <div class="button-container">
        <div class="checkbox-label">
          <RadioButton
            name="foreignLanguagesYesNo"
            value="Da"
            inputId="foreignLanguagesYesNo-da"
            v-model="selectAnswerT2"
          />
          <label for="foreignLanguagesYesNo-da" class="label">Da</label>

          <RadioButton
            name="foreignLanguagesYesNo"
            value="Ne"
            inputId="foreignLanguagesYesNo-ne"
            v-model="selectAnswerT2"
          />
          <label for="foreignLanguagesYesNo-ne" class="label">Ne</label>
        </div>
      </div>

      <div v-if="selectAnswerT2 === 'Da'">
        <h4>23.1 Koji strani/e jezik/e govorite?</h4>
        <InputText
          type="text"
          name="foreignLanguages"
          v-model="foreignLanguages"
        />
        <h4>
          23.2 Da li biste voljeli da unaprijedite znanje jezika koji/e
          govorite?
        </h4>
        <div class="button-container">
          <div class="checkbox-label">
            <RadioButton
              name="improveForeignLanguages"
              value="Da"
              inputId="improveForeignLanguages-da"
              v-model="selectAnswerT4"
            />
            <label for="improveForeignLanguages-da" class="label">Da</label>

            <RadioButton
              name="improveForeignLanguages"
              value="Ne"
              inputId="improveForeignLanguages-ne"
              v-model="selectAnswerT4"
            />
            <label for="improveForeignLanguages-ne" class="label">Ne</label>
          </div>
        </div>
      </div>

      <div v-if="selectAnswerT2 === 'Ne'">
        <h4>23.3 Da li biste željeli da naučite neki strani jezik?</h4>
        <div class="button-container">
          <div class="checkbox-label">
            <RadioButton
              name="learnForeignLanguages"
              value="Da"
              inputId="learnForeignLanguages-da"
              v-model="selectAnswerT3"
            />
            <label for="learnForeignLanguages-da" class="label">Da</label>

            <RadioButton
              name="learnForeignLanguages"
              value="Ne"
              inputId="learnForeignLanguages-ne"
              v-model="selectAnswerT3"
            />
            <label for="learnForeignLanguages-ne" class="label">Ne</label>

            <RadioButton
              name="learnForeignLanguages"
              value="Ne znam"
              inputId="learnForeignLanguages-neznam"
              v-model="selectAnswerT3"
            />
            <label for="learnForeignLanguages-neznam" class="label">Ne znam</label>
          </div>
        </div>
      </div>

      <h4>24. Da li poznajete rad na računaru?</h4>
      <div class="button-container">
        <div class="checkbox-label">
          <RadioButton
            name="workOnComputer"
            value="Da"
            inputId="workOnComputer-da"
            v-model="selectAnswerT5"
          />
          <label for="workOnComputer-da" class="label">Da</label>

          <RadioButton
            name="workOnComputer"
            value="Ne"
            inputId="workOnComputer-ne"
            v-model="selectAnswerT5"
          />
          <label for="workOnComputer-ne" class="label">Ne</label>
        </div>
      </div>
      <div v-if="selectAnswerT5 === 'Ne'">
        <h4>24.1 Da li biste željeli da naučite?</h4>
        <div class="button-container">
          <div class="checkbox-label">
            <RadioButton
              name="learnWorkOnComputer"
              value="Da"
              inputId="learnWorkOnComputer-da"
              v-model="selectAnswerT6"
            />
            <label for="learnWorkOnComputer-da" class="label">Da</label>

            <RadioButton
              name="learnWorkOnComputer"
              value="Ne"
              inputId="learnWorkOnComputer-ne"
              v-model="selectAnswerT6"
            />
            <label for="learnWorkOnComputer-ne" class="label">Ne</label>
          </div>
        </div>
      </div>

      <h4>25. Da li imate hobi?</h4>
      <div class="button-container">
        <div class="checkbox-label">
          <RadioButton
            name="hobbyYesNo"
            value="Da"
            inputId="hobbyYesNo-da"
            v-model="selectAnswerT7"
          />
          <label for="hobbyYesNo-da" class="label">Da</label>

          <RadioButton
            name="hobbyYesNo"
            value="Ne"
            inputId="hobbyYesNo-ne"
            v-model="selectAnswerT7"
          />
          <label for="hobbyYesNo-ne" class="label">Ne</label>
        </div>
      </div>
      <div v-if="selectAnswerT7 === 'Da'">
        <h4>25.1 Navedite svoj/e hobi/je</h4>
        <InputText type="text" name="hobby" v-model="hobby" />
      </div>

      <h4>26. Da li se bavite sportom?</h4>
      <div class="button-container">
        <div class="checkbox-label">
          <RadioButton
            name="sportYesNo"
            value="Da"
            inputId="sportYesNo-da"
            v-model="selectAnswerT8"
          />
          <label for="sportYesNo-da" class="label">Da</label>

          <RadioButton
            name="sportYesNo"
            value="Ne"
            inputId="sportYesNo-ne"
            v-model="selectAnswerT8"
          />
          <label for="sportYesNo-ne" class="label">Ne</label>
        </div>
      </div>
      <div v-if="selectAnswerT8 === 'Da'">
        <h4>26.1 Kojim sportom/vima se bavite?</h4>
        <InputText type="text" v-model="sport" name="sport" />
      </div>

      <h4>27. Zainteresovan/a sam za učešće na:</h4>
      <div class="relative">
        <MultiSelect
          v-model="selectedI"
          :options="interests"
          optionLabel="period"
          placeholder="Izaberite "
          :maxSelectedLabels="20"
          class="w-full md:w-20rem"
          appendTo="body"
          :panelStyle="{ maxWidth: 'calc(100vw - 40px)', overflowX: 'hidden' }"
        />
      </div>

      <h4>
        28. Da li ste zainteresovani da učestvujete u kreiranju usluga i
        politika koje doprinose poboljšanju uslova života osoba s invaliditetom
        u Crnoj Gori?
      </h4>
      <div class="button-container">
        <div class="checkbox-label">
          <RadioButton
            name="createServicesAndPolitics"
            value="Da"
            inputId="createServicesAndPolitics-da"
            v-model="selectAnswerT9"
          />
          <label for="createServicesAndPolitics-da" class="label">Da</label>

          <RadioButton
            name="createServicesAndPolitics"
            value="Ne"
            inputId="createServicesAndPolitics-ne"
            v-model="selectAnswerT9"
          />
          <label for="createServicesAndPolitics-ne" class="label">Ne</label>

          <RadioButton
            name="createServicesAndPolitics"
            value="Ne znam"
            inputId="createServicesAndPolitics-neznam"
            v-model="selectAnswerT9"
          />
          <label for="createServicesAndPolitics-neznam" class="label">Ne znam</label>
        </div>
      </div>

      <h4>
        29. U kom vremenskom periodu možete da se posvetite aktivnostima I MI
        Boke? <br />Možete izabrati više odgovora
      </h4>
      <div class="relative">
        <MultiSelect
          v-model="selectedPeriods"
          :options="periods"
          optionLabel="period"
          placeholder="Izaberite period"
          :maxSelectedLabels="20"
          class="w-full md:w-20rem"
          appendTo="body"
        />
      </div>

      <h4>30. Kako mislite da Vi možete doprinijeti radu I MI Boke?</h4>
      <Textarea
        autoResize
        rows="3"
        cols="47"
        name="contributeToTheWork"
        v-model="contributeToTheWork"
      />

      <h4>31. Koja su Vaša očekivanja od učlanjenja u I MI Boke?</h4>
      <Textarea
        autoResize
        rows="3"
        cols="47"
        name="expectationsOfIMIBoke"
        v-model="expectationsOfIMIBoke"
      />

      <div class="button-container">
        <Button
          @click="goBack"
          class="sendAnswers"
          type="button"
          outlined
          style="margin-right: 5px;"
          >Nazad</Button
        >
        <Button type="submit" class="sendAnswers">Nastavi</Button>
      </div>
    </form>
  </div>
  <FourthSection v-if="returnFourhSection" />
</template>

<script setup>
import FourthSection from "./FourthSection.vue";
import { inject, ref, nextTick, provide } from "vue";

const objekat = inject("objekat");
const pageContainer = inject("pageContainer");

//ide naziv trenutne sekcije
const returnThirdSection = inject("returnThirdSection");

const scrollToTop = () => {
  nextTick(() => {
    if (pageContainer.value) {
      // Ako je roditeljski element sa overflowom (npr. overflow-y: auto)
      pageContainer.value.scrollTop = 0;
    } else {
      // Rezervna opcija: skrolovanje celog prozora
      window.scrollTo({ top: 0, behavior: "auto" });
    }
  });
};

//ovdje ide naziv naredne sekcije
const returnFourhSection = ref(false);
provide("returnFourhSection", returnFourhSection);

const interests = [
  { period: "Radionicama u trajanju do dva sata" },
  { period: "Jednodnevnim seminarima/treninzima" },
  { period: "Seminarima/treninzima u trajanju od dva dana i više" },
  { period: "Višenedjeljnim obukama/kursevima" },
  {
    period:
      "Online vebinarima/predavanjima/kursevima (pohađaju se kad osobi najviše odgovara)",
  },
  {
    period:
      "Uživo i/ili online okruglim stolovima/konferencijama/javnim debatama",
  },
  { period: "Višenedjeljnim putovanjima u zemlji" },
  { period: "Višednevnim putovanjima van zemlje" },
  { period: "Izletima" },
  { period: "Druženjima" },
  { period: "Sportskim aktivnostima i događajima" },
  { period: "Kulturnim aktivnostima i događajima" },
];

const periods = [
  { period: "Prije podne" },
  { period: "Poslije podne" },
  { period: "Tokom državnih praznika" },
  { period: "Vikendima" },
  { period: "Tokom godišnjeg odmora" },
  { period: "Bilo koji dan" },
  { period: "Ostalo" },
];

// Vraća izbor iz MultiSelect-a mapiran na objekte iz liste opcija (poređenje po "period"),
// da bi prethodno sačuvane vrijednosti bile prikazane kao izabrane.
function restoreSelection(options, saved) {
  if (!Array.isArray(saved)) return saved ?? null;
  return saved
    .map((item) => {
      const period = item && typeof item === "object" ? item.period : item;
      return options.find((o) => o.period === period) || (period ? { period } : null);
    })
    .filter(Boolean);
}

const clean = (v) => (typeof v === "string" ? v.trim() : v);

// ---- Stanje forme (inicijalizovano iz objekta, da se ništa ne izgubi pri povratku nazad) ----
const selectAnswerT = ref(objekat.rightsOfPersonsWithDisabilities);
const selectAnswerT2 = ref(objekat.foreignLanguagesYesNo);
const foreignLanguages = ref(objekat.foreignLanguages || "");
const selectAnswerT4 = ref(objekat.improveForeignLanguages);
const selectAnswerT3 = ref(objekat.learnForeignLanguages);
const selectAnswerT5 = ref(objekat.workOnComputer);
const selectAnswerT6 = ref(objekat.learnWorkOnComputer);
const selectAnswerT7 = ref(objekat.hobbyYesNo);
const hobby = ref(objekat.hobby || "");
const selectAnswerT8 = ref(objekat.sportYesNo);
const sport = ref(objekat.sport || "");
const selectedI = ref(restoreSelection(interests, objekat.interestedInParticipating));
const selectAnswerT9 = ref(objekat.createServicesAndPolitics);
const selectedPeriods = ref(restoreSelection(periods, objekat.timeforActivitiesIMIBoke));
const contributeToTheWork = ref(objekat.contributeToTheWork || "");
const expectationsOfIMIBoke = ref(objekat.expectationsOfIMIBoke || "");

// Upisuje stanje sekcije u objekat. Tekst uslovnih pitanja se šalje samo ako je pitanje prikazano.
const saveToObjekat = () => {
  objekat.rightsOfPersonsWithDisabilities = selectAnswerT.value;
  objekat.foreignLanguagesYesNo = selectAnswerT2.value;
  objekat.foreignLanguages = selectAnswerT2.value === "Da" ? clean(foreignLanguages.value) : null;
  // Nazivi polja moraju odgovarati backend modelu (OsiPerson.improveForeignLanguages / learnForeignLanguages)
  objekat.improveForeignLanguages = selectAnswerT4.value;
  objekat.learnForeignLanguages = selectAnswerT3.value;
  objekat.workOnComputer = selectAnswerT5.value;
  objekat.learnWorkOnComputer = selectAnswerT6.value;
  objekat.hobbyYesNo = selectAnswerT7.value;
  objekat.hobby = selectAnswerT7.value === "Da" ? clean(hobby.value) : null;
  objekat.sportYesNo = selectAnswerT8.value;
  objekat.sport = selectAnswerT8.value === "Da" ? clean(sport.value) : null;
  objekat.interestedInParticipating = selectedI.value;
  objekat.createServicesAndPolitics = selectAnswerT9.value;
  objekat.timeforActivitiesIMIBoke = selectedPeriods.value;
  objekat.contributeToTheWork = clean(contributeToTheWork.value);
  objekat.expectationsOfIMIBoke = clean(expectationsOfIMIBoke.value);
};

const goBack = () => {
  // Sačuvaj unos i na povratku, da ne nestane kad se korisnik vrati naprijed
  saveToObjekat();
  returnThirdSection.value = false; // Sakrivaš treću sekciju -> prikazuje se druga
  scrollToTop();
};

const onSubmit = () => {
  saveToObjekat();
  returnFourhSection.value = true;
  scrollToTop();
};
</script>
